import React, { Component } from 'react';
import { Col, Row, Button, Glyphicon, Alert, Panel } from 'react-bootstrap';
import {connect} from 'react-redux';

import { updateEducationInfo, addCollege, removeCollege, saveEducationInfo } from '../actions';
import EducationValidation, { CollegeValidation, EducationValidationPT } from '../validation/educationValidation';

import College from './College';
import EducationRequirements from './EducationRequirements';
import FormSectionStatus from './FormSectionStatus';
import { PROGRAM_ADN } from "../config/constants";

class EducationInfo extends Component {
  constructor(props){
    super(props);
    this.saveAndContinue = this.saveAndContinue.bind(this);
    this.handleChange = this.handleChange.bind(this);
    EducationInfo.getValidationState = EducationInfo.getValidationState.bind(this);
    this.handleAddCollege = this.handleAddCollege.bind(this);
    this.handleRemoveCollege = this.handleRemoveCollege.bind(this);
  }

  saveAndContinue(e){
    e.preventDefault();
    if(EducationInfo.getValidationState() === 'success') {
      console.log('Update Database');
      this.props.dispatch(saveEducationInfo(this.props.educationInfo));
      //this.props.nextStep();
    } else {
      console.log('Not Saved');
    }
  }

  handleChange(e){
    const { dispatch } = this.props;
    let updates = {};
    updates[e.target.id] = e.target.value;
    dispatch(updateEducationInfo(updates));
  }

  static getValidationState(){
    return 'success';
  }

  handleAddCollege(e){
    e.preventDefault();
    const {dispatch} = this.props;
    dispatch(addCollege());
  }

  handleRemoveCollege(collegeId){
    const {dispatch} = this.props;
    dispatch(removeCollege(collegeId));
  }

  render() {
    const { educationInfo, programId } = this.props;
    const validationStatus = programId === PROGRAM_ADN ?
      new EducationValidation().getValidationStatus(educationInfo) :
      new EducationValidationPT().getValidationStatus(educationInfo);
    const space = ' ';

    const renderInstructions = () => {
      return programId === PROGRAM_ADN ? (
        <div>
          <h3>Criteria 2: Prerequisite Coursework</h3>
          <Row>
            <Col sm={12}>
              <p>
                Please note that you <strong>MUST HAVE A MINIMUM 2.50 GPA</strong> in each area, Science and
                Non-Science to be eligible for admission to our program. <em className="text-danger">Grades C- and
                below are not accepted but must be entered to calculate repeats.</em>
              </p>
              <p>
                For any <em className="text-danger">Science Prerequisite requirement</em> course in which a grade of
                "C" or better was earned, the EARLIEST course grade (or first passing attempt) will be utilized in the
                GPA Calculation as per college policy. All other attempts must be listed as "repeats." Do NOT include
                courses with "EW" grades. "EW" grades are not considered repeats.
              </p>
              <p>
                Please refer to your academic records to complete this section. Please record information accurately;
                <em className="text-danger">inaccurate information will result in disqualification.</em>
              </p>
              <p>
                Advanced Placement Students: Enter your information for H S 43 below and See Criterion 1B to request
                advanced placement.
              </p>
              <p>
                Please list all attempts at each class.
              </p>
            </Col>
          </Row>
        </div>
      ) :
      (
        <div>
          <h3>Prerequisite Coursework</h3>
          <Row>
            <Col sm={12}>
              <p>
                You must have taken and passed the following with a minimum cumulative grade point average (GPA) of
                2.5 (Passing grade is A, B, C; <em className="text-danger">Grades C- and below are not accepted</em>):
              </p>
            </Col>
          </Row>
        </div>
      )
    };

    const renderColleges = () => {
      if(educationInfo.colleges.length === 0) {
        return (
          <Alert bsStyle="warning">
            Please add a college to begin academic information.
          </Alert>
        )
      }

      return educationInfo.colleges.map((college) => {
        const validationState = new CollegeValidation().getValidationStatus(college);
        return (
          <College
            key={college.id}
            {...college}
            programId={this.props.programId}
            validationState={validationState}
            dispatch={this.props.dispatch}
            onRemoveCollege={this.handleRemoveCollege}/>
        );
      });
    };

    return (
      <div>
        <h2>Education Information</h2>
        <Panel>
        {renderInstructions()}
        <EducationRequirements />
        {renderColleges()}
        <Row style={{marginBottom: '15px'}}>
          <Col xs={12}>
            <Button onClick={this.handleAddCollege}>
              <Glyphicon glyph="plus"/>
              {space} Add College
            </Button>
          </Col>
        </Row>
        </Panel>
        <FormSectionStatus {...validationStatus.section}/>
      </div>
    );
  };
}

export default connect(
  (state) => {
    const { appInfo, educationInfo } = state;
    const { programId } = appInfo.application;
    return {
      educationInfo,
      programId
    };
  }
)(EducationInfo);